import { Link } from "react-router-dom";

function NotFound() {
    return (
        <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
            <h1 className="text-6xl font-bold text-red-500 mb-4">404</h1>
            <h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
            <p className="text-gray-600 mb-6">
                The link you opened is not valid. Please go back to our website homepage.
            </p>

            <Link
                to="/"
                className="bg-gradient-to-r
 from-[#174EA6]
 via-[#174EA6]
 to-[#8B0000]
 hover:from-[#123D85] 
      text-white px-6 py-3 rounded-lg shadow-md 
      hover:from-teal-600 hover:to-blue-600 
      hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
                Go to Home Page
            </Link>
        </div>
    );
}

export default NotFound;